import StatementAlert from '@Components/Bases/StatementAlert';
import { Box, Typography } from '@mui/material';

const Alerts = () => {
  return (
    <>
      <Typography variant="h3">Custom Alert</Typography>
      <Box mt={2}>
        <StatementAlert statement="ใส่ข้อความหรือคำชี้แจ้งของคุณมาสิจ้ะ" />
      </Box>
    </>
  );
};

export default Alerts;
